// Section 4 phase 9 (Deaths, aging) and Section 15: deaths at health 0 and from old age; pairing
// (answers to last season's pairing prompts, new pairs, couples moving in together); pregnancy,
// childbirth and conception; aging and status countdowns. Then the end-of-season social marks
// (Section 16): norm counters and the Charismatic trust spread, which need the crime phase's
// justice entries of this season.
import type { Phase } from '../../core/types';
import { age } from './aging';
import { conceive, progressPregnancies } from './births';
import { spreadCharisma } from './charisma';
import { resolveDeaths } from './deaths';
import { bedBook } from './households';
import { updateNorms } from './norms';
import { answerPairings, reunite, rollPairings } from './pairing';

export const lifecyclePhase: Phase = {
  id: 'lifecycle',
  reads: ['people', 'households', 'currentReport', 'policies', 'openPrompts', 'norms', 'stocks'],
  writes: [
    'people',
    'households',
    'formerPeople',
    'currentReport',
    'nextIds',
    'openPrompts',
    'norms',
    'stocks',
  ],
  projection: 'skip',
  run(ctx) {
    // Section 5 Charismatic: spread this season's household trust changes (committed state).
    spreadCharisma(ctx);
    resolveDeaths(ctx);
    const beds = bedBook(ctx);
    answerPairings(ctx, beds);
    rollPairings(ctx, beds);
    reunite(ctx, beds);
    const delivered = progressPregnancies(ctx);
    conceive(ctx, delivered);
    age(ctx);
    updateNorms(ctx);
    return 'done';
  },
};
